import React from "react";
import dynamic from "next/dynamic";

import useMobile from "../../hooks/useMobile";

const Masthead = dynamic(() => import("./Desktop/Masthead"));
const SectionNav = dynamic(() => import("./Desktop/SectionNav"));
const MobileHeader = dynamic(() => import("./Mobile/MobileHeader"));

const Navbar = () => {
  const isMobile = useMobile();

  return isMobile ? (
    <div>
      <MobileHeader />
    </div>
  ) : (
    <div className="z-10 relative bg-white">
      <Masthead />
      <SectionNav />
    </div>
  );
};

export default React.memo(Navbar);
